import { Link } from "react-router-dom";
import { Product } from "../types";
import { money } from "../api";
import { Heart, Scale } from "lucide-react";
import { useShop } from "../context/ShopContext";

const labelMap = { buy_now: "Add to cart", quote: "Quote item", inquiry: "Inquiry item" };

export function ProductCard({ product }: { product: Product }) {
  const { wishlist, compare, toggleWishlist, toggleCompare } = useShop();
  const displayPrice = product.price ? money(product.price.amount, product.price.currency) : `From ${money(product.starting_at?.amount, product.starting_at?.currency)}`;
  const badge = product.inventory_flag === "catalog_item" ? "Best Seller" : product.purchase_type === "quote" ? "Freight Review" : "Room Ready";
  return (
    <article className="product-card" data-testid={`product-card-${product.slug}`}>
      <Link to={`/product/${product.slug}`} data-testid={`product-card-link-${product.slug}`}>
        <div className="product-image-wrap" data-testid={`product-image-wrap-${product.slug}`}>
          <img src={product.images[0]} alt={product.name} data-testid={`product-image-${product.slug}`} />
          <span className={`purchase-badge ${product.purchase_type}`} data-testid={`product-purchase-type-${product.slug}`}>{labelMap[product.purchase_type]}</span>
        </div>
        <div className="product-card-body">
          <p className="product-brand" data-testid={`product-brand-${product.slug}`}>{product.brand_slug.replaceAll("-", " ")}</p>
          <h3 data-testid={`product-name-${product.slug}`}>{product.name}</h3>
          <p data-testid={`product-description-${product.slug}`}>{product.short_description}</p>
          <div className="product-meta-row" data-testid={`product-meta-${product.slug}`}><strong data-testid={`product-price-${product.slug}`}>{displayPrice}</strong><span data-testid={`product-badge-${product.slug}`}>{badge}</span></div>
        </div>
      </Link>
      <div className="product-card-actions" data-testid={`product-card-actions-${product.slug}`}>
        <button type="button" onClick={() => toggleWishlist(product.slug)} data-testid={`wishlist-toggle-${product.slug}`}><Heart size={15} fill={wishlist.includes(product.slug) ? "currentColor" : "none"}/> {wishlist.includes(product.slug) ? "Saved" : "Save"}</button>
        <button type="button" onClick={() => toggleCompare(product.slug)} data-testid={`compare-toggle-${product.slug}`}><Scale size={15}/> {compare.includes(product.slug) ? "Added" : "Compare"}</button>
      </div>
    </article>
  );
}